import gql from 'graphql-tag'

export default gql`
query getServiceTypeSettingInBulk( $typeValues: [String!]!){
    getServiceTypeSettingInBulk(typeValues: $typeValues){
    domain
    typeValue
    siteId
    quantityReq
    isKotAllowed
    isCustomItem
    cancelResons
    whatsAppNumber
    diningArea
    regardsName
    printOrderIdOnBill
    printOrderIdBarcodeOnBill
    taxMethod
    minOrderValue
    showPaymentOption
    showBilledAmountCaptain
    discountReason
    chargesReason
    isCustomerSegment
    customCharges{
      customChargeName
      customChargeList{
        name
        rate
        chargeType
        taxType
        tax
        defaultSelcted
        chargesAppliedOnInclusive
        chargeFor
      }
    }
    customFeilds{
      customType
      customName
      customValue
      customListValue
      menuAttached
      required
      availability
      length
    }
    availableFeilds{
      
      availableType
      displayName
      display
      menuAttached
      required
    }
    formSchemas{
      id
      type
      customType
      customName
      customValue
      customListValue
      required
      isProfileField
      display
      availability
      length
      isVerification
      verificationFormat
      displayOrder
      groupBy
      action
      min
      max
    }
    orderButtons
    orderCaptainButtons
    payButtons
    # minMax
  }
}




`


// # {
  // #   "typeValue": "dine-in::setting"
    
  // # }
  